// Mock data for the real estate portfolio website

export const stats = [
  {
    icon: 'TrendingUp',
    value: '200+',
    label: 'Successful Transactions'
  },
  {
    icon: 'Award',
    value: '15 Years',
    label: 'Industry Experience'
  },
  {
    icon: 'Users',
    value: '100+',
    label: 'Investment Units Closed'
  }
];

export const investmentFeatures = [
  {
    icon: 'TrendingUp',
    title: 'Portfolio Growth',
    description: 'Strategic investments designed to maximize returns and build long-term wealth.'
  },
  {
    icon: 'PieChart',
    title: 'Diversification',
    description: 'Balanced portfolio strategies across commercial, residential, and mixed-use properties.'
  },
  {
    icon: 'Target',
    title: 'Market Analysis',
    description: 'Data-driven insights and market intelligence to identify prime investment opportunities.'
  },
  {
    icon: 'Shield',
    title: 'Risk Management',
    description: 'Comprehensive due diligence and risk assessment to protect your investments.'
  }
];

export const investmentStats = [
  {
    label: 'Average IRR',
    value: '12.5%',
    image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc2ODA4OTg5OHww&ixlib=rb-4.1.0&q=85'
  },
  {
    label: 'Properties Sold',
    value: '200+',
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc2ODA4OTg5OHww&ixlib=rb-4.1.0&q=85'
  }
];

export const brokerageFeatures = [
  {
    icon: 'Search',
    title: 'Property Search',
    description: 'Access to exclusive listings and off-market opportunities tailored to your needs.'
  },
  {
    icon: 'Handshake',
    title: 'Expert Negotiation',
    description: 'Skilled negotiators ensuring you get the best deal, whether buying or selling.'
  },
  {
    icon: 'BarChart3',
    title: 'Market Expertise',
    description: 'Deep knowledge of local markets and trends to guide your decisions.'
  },
  {
    icon: 'CheckCircle2',
    title: 'Full-Service Support',
    description: 'From initial search to closing, we handle every detail of your transaction.'
  }
];

export const propertyManagementFeatures = [
  {
    icon: 'Building2',
    title: 'Property Oversight',
    description: 'Comprehensive management of residential and commercial properties with proactive maintenance.'
  },
  {
    icon: 'Users2',
    title: 'Tenant Relations',
    description: 'Professional tenant screening, onboarding, and ongoing relationship management.'
  },
  {
    icon: 'Wrench',
    title: 'Maintenance & Repairs',
    description: '24/7 maintenance coordination and quality vendor relationships for timely repairs.'
  },
  {
    icon: 'FileText',
    title: 'Financial Reporting',
    description: 'Detailed monthly reports, rent collection, and transparent financial management.'
  }
];

export const propertyManagementStats = [
  {
    value: '20+',
    label: 'Properties Managed'
  },
  {
    value: '98%',
    label: 'Tenant Satisfaction'
  },
  {
    value: '24/7',
    label: 'Support Available'
  }
];

export const teamMembers = [
  {
    name: 'Shawn Hartley',
    role: 'Broker BIC',
    specialties: ['Brokerage', 'Investments'],
    image: 'https://customer-assets.emergentagent.com/job_estate-portfolio-9/artifacts/eerlm7sj_1752071500209.jpg'
  },
  {
    name: 'Sheena Criswell',
    role: 'Real Estate Agent',
    specialties: ['Residential', 'Bankruptcy Trustee Representation'],
    image: 'https://customer-assets.emergentagent.com/job_estate-portfolio-9/artifacts/xdmjl8jk_sheena.jpg'
  }
];

export const contactInfo = {
  phone: '(555) 123-4567',
  email: 'info@risereal.com',
  address: {
    street: '123 Business Plaza',
    suite: 'Suite 500',
    city: 'Metropolitan City, ST 12345'
  }
};